import React from 'react';

import { Table } from '@morressier/alembic';
import { Text } from '@chakra-ui/react';
import { IPeerReviewSubmissionScore } from '@publishing-engine/domain/models';

interface ReviewTableScoreProps {
  submissionScores: IPeerReviewSubmissionScore;
  reviewFieldConfig: any;
}

const ReviewTableScore: React.FC<ReviewTableScoreProps> = ({
  submissionScores,
  reviewFieldConfig
}) => {
  return (
    <Table>
      <Table.HeaderRow>
        <Table.HeaderCell flex="1" textAlign="left">
          Criteria
        </Table.HeaderCell>
        <Table.HeaderCell flex="1" textAlign="left">
          Score
        </Table.HeaderCell>
      </Table.HeaderRow>
      <Table.Body sx={{ borderTop: 'none' }}>
        {Object.entries(submissionScores).map(([name, score]) => {
          const field = reviewFieldConfig[name];
          const scoreText = field?.params?.labels?.options[score] || {
            main: '',
            secondary: ''
          };

          return (
            <Table.Row key={name}>
              <Table.RowCell flex="1" textStyle="headingItem" textAlign="left">
                {field?.name}
              </Table.RowCell>
              <Table.RowCell flex="1" textAlign="left">
                <Text textStyle="headingItem">{scoreText?.main}</Text>
                <Text textStyle="textContext">{scoreText?.secondary}</Text>
              </Table.RowCell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default ReviewTableScore;
